import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { Font } from "./TextFormatSettings";
import useVariableValues from "../../hooks/useVariableValues";

const PROPS: (keyof Font)[] = [
  "fontSize",
  "textAlign",
  "tag",
  "textDecoration",
  "fontWeight",
  "fontStyle",
  "fontFamily",
  "color",
];

const useNormalizeTextFormatSettings = (props: Font) => {
  const responsive = useResponsiveValues();
  const vv = useVariableValues(true);

  const draft = useMemo(() => {
    const draft: Font = {};

    PROPS.forEach((prop) => {
      const value = responsive.getValue(props[prop]);

      if (prop === "color") {
        draft[prop] = vv.getValue(value ?? "");
      } else if (props[prop]) {
        draft[prop] = value;
      }
    });

    return draft;
  }, [props, responsive, vv]);
  return draft;
};

export default useNormalizeTextFormatSettings;
